<section class="hero" id="hero" aria-label="Hero section">
  <!-- Decorative rotating tech ring — purely visual, hidden from screen readers -->
  <div class="hero__donut" aria-hidden="true">
    <div #ringsCanvas class="canvas" aria-hidden="true"></div>
  </div>

  <div class="hero__container">
    <app-central-banner></app-central-banner>
    <div class="hero__grid">

      <!-- ─── Left Column: Content ─────────────────────────────────────────── -->
      <div class="hero__content">



        <!-- Primary heading — exactly one H1 per page -->
        <h1 class="hero__title">
          <span class="hero__title-line">{{ 'banner.title_line_1' | translate }}</span>
          <span class="hero__title-line text-primary">{{ 'banner.title_line_2' | translate }}</span>
        </h1>

        <!-- Live status badge -->
        <div class="d-flex align-items-start gap-sm-3 gap-2 justify-content-center justify-content-sm-start flex-wrap">
          <div class="hero__badge">
            <span class="hero__badge-dot" aria-hidden="true"></span>
            <span>{{ 'banner.live_badge' | translate }}</span>
          </div>
          <!-- <span class="hero__badge"><span class="dot"></span> BONUS STAGE NOW LIVE</span> -->
        </div>
        <!-- Description -->
        <p class="hero__desc">{{ 'banner.description' | translate }}</p>

        <!-- CTA buttons -->
        <div class="hero__ctas mb-4 mb-sm-0">
          <button class="hero__btn hero__btn--primary" (click)="openVideoModal()">
            <strong>{{ 'banner.watch_demo' | translate }}</strong>
          </button>
          <a class="hero__btn hero__btn--ghost" href="https://seerdex.gitbook.io/seerdex-whitepaper" target="_blank" rel="noopener noreferrer" (click)="trackDocumentClick('documentation', 'https://seerdex.gitbook.io/seerdex-whitepaper')">
            <strong>{{ 'banner.documentation' | translate }}</strong>
          </a>
        </div>
        <div class="d-none d-lg-block">
          <app-race-to-tge></app-race-to-tge>
        </div>

      </div>
      <!-- ─── End Left Column ──────────────────────────────────────────────── -->

      <!-- ─── Right Column: Buy Widget ─────────────────────────────────────── -->
      <div class="hero__widget-wrap">
        <app-widget></app-widget>
        <app-latest-purchase></app-latest-purchase>
        <div class="d-block d-lg-none">
          <app-race-to-tge></app-race-to-tge>
        </div>
      </div>
      <!-- ─── End Right Column ─────────────────────────────────────────────── -->

    </div>
  </div>

</section>